import React from 'react'

const Form = props => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Reason</label>
                    </div>
                    <div className="form-input">
                        <textarea type="text" name="reason" value={props.reason} onChange={props.onChange} />
                        <span className="error">{props.errors.reason}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="submit">Reject</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default Form